// import React from 'react';
// import { BrowserRouter as Router, Route, Routes, useLocation } from 'react-router-dom';

// import './App.css';

// import Signup from './Components/MainPages/Signup';
// import ForgotPassword from './Components/MainPages/ForgotPassword';
// import ResetPassword from './Components/MainPages/ResetPassword';
// import OTPverify from './Components/MainPages/OTPverify';
// import Register from './Components/MainPages/Register';
// import Create from './Components/Matrimony/Pages/Create';
// import PartnerPreference from './Components/Matrimony/Pages/Preference';
// import HomeList from './Components/Matrimony/Pages/HomeList';
// import Profile from './Components/Matrimony/Pages/Profile';
// import HomePage from './Components/Matrimony/Pages/Homepage';
// import Subscription from './Components/Matrimony/Pages/Subscription';
// import UserPage from './Components/Matrimony/Pages/UserPage';
// import Chatroom from './Components/Matrimony/Chating/Chatroom';
// import SplashScreen from './Components/MainPages/SplashScreen';
// import Notifications from './Components/Matrimony/Pages/Notifications';
// import ChatPage from './Components/Matrimony/Chating/ChatPage';
// import LegalUserView from './Components/Matrimony/Pages/LegalAdminUserView';
// import ReviewPage from './Components/Matrimony/Pages/ReviewPage';
// import Footer from './Components/Matrimony/Pages/Footer';
// import MainNavbar from './Components/Matrimony/MainNavbar';
// import AstrologyConsultation from './Components/Matrimony/Pages/AstrologyConsultation';
// import AstrologerRegister from './Components/MainPages/AstrologerRegister';
// import AstrologerLogin from './Components/MainPages/AstrologerLogin';
// import AboutUs from './Components/Matrimony/Pages/aboutus';
// import AdminDashboard from './Components/Matrimony/AdminPanel/AdminDashboard';
// import AdminNavbar from './Components/Matrimony/AdminNavbar';
// import UserManagement from './Components/Matrimony/AdminPanel/UserManagement';
// import AdminPanel from './Components/Matrimony/AdminPanel/AdminPanel';
// import AdminMatchmakingPanel from './Components/Matrimony/AdminPanel/AdminMatchmakingPanel';
// import AdminNotificationPanel from './Components/Matrimony/AdminPanel/Notificationpageadmin';
// import AdminReportPage from './Components/Matrimony/AdminPanel/AdminReportPage';
// import AdminReview from './Components/Matrimony/AdminPanel/adminreview';
// import AdminHome from './Components/Matrimony/AdminPanel/AdminHome';
// import AdminProfile from './Components/Matrimony/AdminPanel/adminProfile';
// import AdminLogin from './Components/Matrimony/AdminPanel/loginadmin';
// import ViewPayments from './Components/Matrimony/AdminPanel/ViewPayments';
// import Emailsms from './Components/Matrimony/AdminPanel/Emailsms';
// import Plans from './Components/Matrimony/AdminPanel/Plans';
// import UserGuidelines from './Components/Matrimony/AdminPanel/UserGuidelines';
// import Aboutus from './Components/Matrimony/AdminPanel/Aboutus';
// import Systemsettings from './Components/Matrimony/AdminPanel/Systemsettings';
// import UserPaymentHistory from './Components/Matrimony/Pages/UserPaymentHistory';
// import RightSideTab from './Components/RightSideTab';
// import UserPlansReport from './Components/Matrimony/AdminPanel/UserPlansReport';
// import ReportsPage from './Components/Matrimony/AdminPanel/ReportsPage';
// import SuccessStoryForm from './Components/Matrimony/Pages/SuccessStoryForm';
// import PrivateRoute from './Components/PrivateRoute';
// import AccountDeactivation from './Components/Matrimony/Pages/AccountDeactivation';
// import ContactUs from './Components/Matrimony/Pages/ContactUs';
// import HelpCenter from './Components/Matrimony/Pages/HelpCenter';
// import SubmitRequest from './Components/Matrimony/Pages/SubmitRequest';
// import UserRequest from './Components/Matrimony/AdminPanel/UserRequest';
// import SearchComponent from './Components/Matrimony/Pages/SearchComponent';

// function MainAppLayout() {
//   const location = useLocation();
//   const isSplash = location.pathname === "/";
//   const allowedPaths = ["/homepage", "/homelist", "/profile", "/subscription", "/create", "/preference"];

//   return (
//     <div className="App">
//       {location.pathname !== '/' && <MainNavbar />}

//       {allowedPaths.includes(location.pathname) && location.pathname !== '/' && <RightSideTab />}

//       <Routes>
//         <Route path="/" element={<SplashScreen />} />
//         <Route path="/signup" element={<Signup />} />
//         <Route path="/forgetpassword1" element={<ForgotPassword />} />
//         <Route path="/reset_password/:id/:token" element={<ResetPassword />} />
//         <Route path="/otpverify" element={<OTPverify />} />
//         <Route path="/register" element={<Register />} />
//         <Route path="/create" element={<Create />} />
//         <Route path="/preference" element={<PartnerPreference />} />
//         <Route path="/homelist" element={<HomeList />} />
//         <Route path="/homepage" element={<HomePage />} />
//         <Route path="/profile" element={<Profile />} />
//         <Route path="/subscription" element={<Subscription />} />
//         <Route path="/userpage/:userId" element={<UserPage />} />
//         <Route path="/chatroom" element={<Chatroom />} />
//         <Route path="/chatpage" element={<ChatPage />} />
//         <Route path="/notification" element={<Notifications />} />
//         <Route path="/legalview" element={<LegalUserView />} />
//         <Route path="/astrology" element={<AstrologyConsultation />} />
//         <Route path="/review" element={<ReviewPage />} />
//         <Route path="/astrologyregister" element={<AstrologerRegister />} />
//         <Route path="/astrologylogin" element={<AstrologerLogin />} />
//         <Route path="/aboutus" element={<AboutUs />} />
//         <Route path="/userpaymenthistory" element={<UserPaymentHistory />} />
//         <Route path="/deactivate" element={<AccountDeactivation />} />
//         <Route path="/contactus" element={<ContactUs />} />
//         <Route path="/successstory" element={<SuccessStoryForm />} />
//         <Route path="/helpcenter" element={<HelpCenter />} />
//         <Route path="/submitrequest" element={<SubmitRequest />} />
//         <Route path="/searchcomponent" element={<SearchComponent />} />
//       </Routes>

//       <Footer />
//     </div>
//   );
// }

// function App() {
//   return (
//     <Router>
//       <Routes>
//         {/* Admin Route: Protected by PrivateRoute */}
//         <Route
//           path="/admin/*"
//           element={
//             <PrivateRoute>
//               <div className="admin-layout">
//                 <AdminNavbar />
//                 <div className="admin-content">
//                   <Routes>
//                     <Route path="/dashboard" element={<AdminDashboard />} />
//                     <Route path="/usermanagement" element={<UserManagement />} />
//                     <Route path="/Astrology" element={<AdminPanel />} />
//                     <Route path="/matching" element={<AdminMatchmakingPanel />} />
//                     <Route path="/notification" element={<AdminNotificationPanel />} />
//                     <Route path="/report" element={<AdminReportPage />} />
//                     <Route path="/review" element={<AdminReview />} />
//                     <Route path="/home" element={<AdminHome />} />
//                     <Route path="/profile" element={<AdminProfile />} />
//                     <Route path="/view" element={<ViewPayments />} />
//                     <Route path="/emailsms" element={<Emailsms />} />
//                     <Route path="/plans" element={<Plans />} />
//                     <Route path="/guidelines" element={<UserGuidelines />} />
//                     <Route path="/about" element={<Aboutus />} />
//                     <Route path="/systemsettings" element={<Systemsettings />} />
//                     <Route path="/userplans" element={<UserPlansReport />} />
//                     <Route path="/overallusersreports" element={<ReportsPage />} />
//                     <Route path="/request" element={<UserRequest />} />
//                   </Routes>
//                 </div>
//               </div>
//             </PrivateRoute>
//           }
//         />

//         {/* Admin Login Route (accessible without auth) */}
//         <Route path="/admin" element={<AdminLogin />} />

//         {/* Public/Main App Route */}
//         <Route path="/*" element={<MainAppLayout />} />
//       </Routes>
//     </Router>
//   );
// }
// export default App;


// import React from 'react';
// import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';

// import './App.css';

// import Signup from './Components/MainPages/Signup';
// import ForgotPassword from './Components/MainPages/ForgotPassword';
// import ResetPassword from './Components/MainPages/ResetPassword';
// import OTPverify from './Components/MainPages/OTPverify';
// import Register from './Components/MainPages/Register';
// import Create from './Components/Matrimony/Pages/Create';
// import PartnerPreference from './Components/Matrimony/Pages/Preference';
// import HomeList from './Components/Matrimony/Pages/HomeList';
// import Profile from './Components/Matrimony/Pages/Profile';
// import HomePage from './Components/Matrimony/Pages/Homepage';
// import Subscription from './Components/Matrimony/Pages/Subscription';
// import UserPage from './Components/Matrimony/Pages/UserPage';
// import Chatroom from './Components/Matrimony/Chating/Chatroom';
// import SplashScreen from './Components/MainPages/SplashScreen';
// import Notifications from './Components/Matrimony/Pages/Notifications';
// import ChatPage from './Components/Matrimony/Chating/ChatPage';
// import LegalUserView from './Components/Matrimony/Pages/LegalAdminUserView';
// import ReviewPage from './Components/Matrimony/Pages/ReviewPage';
// import Footer from './Components/Matrimony/Pages/Footer';
// import MainNavbar from './Components/Matrimony/MainNavbar';
// import AstrologyConsultation from './Components/Matrimony/Pages/AstrologyConsultation';
// import AstrologerRegister from './Components/MainPages/AstrologerRegister';
// import AstrologerLogin from './Components/MainPages/AstrologerLogin';
// import AboutUs from './Components/Matrimony/Pages/aboutus';
// import AdminDashboard from './Components/Matrimony/AdminPanel/AdminDashboard';
// import AdminNavbar from './Components/Matrimony/AdminNavbar';
// import UserManagement from './Components/Matrimony/AdminPanel/UserManagement';
// import AdminPanel from './Components/Matrimony/AdminPanel/AdminPanel';
// import AdminMatchmakingPanel from './Components/Matrimony/AdminPanel/AdminMatchmakingPanel';
// import AdminNotificationPanel from './Components/Matrimony/AdminPanel/Notificationpageadmin';
// import AdminReportPage from './Components/Matrimony/AdminPanel/AdminReportPage';
// import AdminReview from './Components/Matrimony/AdminPanel/adminreview';
// import AdminHome from './Components/Matrimony/AdminPanel/AdminHome';
// import AdminProfile from './Components/Matrimony/AdminPanel/adminProfile';
// import AdminLogin from './Components/Matrimony/AdminPanel/loginadmin';
// import ViewPayments from './Components/Matrimony/AdminPanel/ViewPayments';
// import Emailsms from './Components/Matrimony/AdminPanel/Emailsms';
// import Plans from './Components/Matrimony/AdminPanel/Plans';
// import UserGuidelines from './Components/Matrimony/AdminPanel/UserGuidelines';
// import Aboutus from './Components/Matrimony/AdminPanel/Aboutus';
// import Systemsettings from './Components/Matrimony/AdminPanel/Systemsettings';
// import UserPaymentHistory from './Components/Matrimony/Pages/UserPaymentHistory';
// import RightSideTab from './Components/RightSideTab';
// import UserPlansReport from './Components/Matrimony/AdminPanel/UserPlansReport';
// import ReportsPage from './Components/Matrimony/AdminPanel/ReportsPage';

// function App() {
//   return (
//     <Router>
//       <Routes>
//         {/* Admin Panel Routes */}
//         <Route
//           path="/admin/*"
//           element={
//             <div className="admin-layout">
//               <AdminNavbar />
//               <div className="admin-content">
//                 <Routes>
//                   <Route path="/" element={<AdminLogin />} />
//                   <Route path="/dashboard" element={<AdminDashboard />} />
//                   <Route path="/usermanagement" element={<UserManagement />} />
//                   <Route path="/Astrology" element={<AdminPanel />} />
//                   <Route path="/matching" element={<AdminMatchmakingPanel />} />
//                   <Route path="/notification" element={< AdminNotificationPanel />} />
//                   <Route path="/report" element={<AdminReportPage />} />
//                   <Route path="/review" element={<AdminReview />} />
//                   <Route path="/home" element={<AdminHome />} />
//                   <Route path="/profile" element={<AdminProfile />} />
//                   <Route path="/view" element={<ViewPayments />} />
//                   <Route path="/emailsms" element={<Emailsms />} />
//                   <Route path="/plans" element={<Plans />} />
//                   <Route path="/guidelines" element={<UserGuidelines />} />
//                   <Route path="/about" element={<Aboutus />} />
//                   <Route path="/systemsettings" element={<Systemsettings />} />
//                   <Route path="/userplans" element={<UserPlansReport/>} />
//                   <Route path="/overallusersreports" element={<ReportsPage/>} />
//                 </Routes>
//               </div>
//             </div>
//           }
//         />

//         {/* Main Application Routes */}
//         <Route
//           path="/*"
//           element={
//             <div className="App">
//               <MainNavbar />
//               <RightSideTab /> {/* <-- Add it here */}
//               <Routes>
//                 <Route path="/" element={<SplashScreen />} />
//                 <Route path="/signup" element={<Signup />} />
//                 <Route path="/forgetpassword1" element={<ForgotPassword />} />
//                 <Route path="/reset_password/:id/:token" element={<ResetPassword />} />
//                 <Route path="/otpverify" element={<OTPverify />} />
//                 <Route path="/register" element={<Register />} />
//                 <Route path="/create" element={<Create />} />
//                 <Route path="/preference" element={<PartnerPreference />} />
//                 <Route path="/homelist" element={<HomeList />} />
//                 <Route path="/homepage" element={<HomePage />} />
//                 <Route path="/profile" element={<Profile />} />
//                 <Route path="/subscription" element={<Subscription />} />
//                 <Route path="/userpage/:userId" element={<UserPage />} />
//                 <Route path="/chatroom" element={<Chatroom />} />
//                 <Route path="/chatpage" element={<ChatPage />} />
//                 <Route path="/notification" element={<Notifications />} />
//                 <Route path="/legalview" element={<LegalUserView />} />
//                 <Route path="/astrology" element={<AstrologyConsultation />} />
//                 <Route path="/review" element={<ReviewPage />} />
//                 <Route path="/astrologyregister" element={<AstrologerRegister />} />
//                 <Route path="/astrologylogin" element={<AstrologerLogin />} />
//                 <Route path="/aboutus" element={<AboutUs />} />
//                 <Route path="/userpaymenthistory" element={<UserPaymentHistory />} />
//               </Routes>
//               <Footer />
//             </div>
//           }
//         />

//       </Routes>
//     </Router>
//   );
// }

// export default App;

import { BrowserRouter as Router, Route, Routes, useLocation } from 'react-router-dom';
import React, { useState, useEffect } from 'react';

import './App.css';

import Signup from './Components/MainPages/Signup';
import ForgotPassword from './Components/MainPages/ForgotPassword';
import ResetPassword from './Components/MainPages/ResetPassword';
import OTPverify from './Components/MainPages/OTPverify';
import Register from './Components/MainPages/Register';
import Create from './Components/Matrimony/Pages/Create';
import PartnerPreference from './Components/Matrimony/Pages/Preference';
import HomeList from './Components/Matrimony/Pages/HomeList';
import Profile from './Components/Matrimony/Pages/Profile';
import HomePage from './Components/Matrimony/Pages/Homepage';
import Subscription from './Components/Matrimony/Pages/Subscription';
import UserPage from './Components/Matrimony/Pages/UserPage';
import Chatroom from './Components/Matrimony/Chating/Chatroom';
import SplashScreen from './Components/MainPages/SplashScreen';
import Notifications from './Components/Matrimony/Pages/Notifications';
import ChatPage from './Components/Matrimony/Chating/ChatPage';
import LegalUserView from './Components/Matrimony/Pages/LegalAdminUserView';
import ReviewPage from './Components/Matrimony/Pages/ReviewPage';
import Footer from './Components/Matrimony/Pages/Footer';
import MainNavbar from './Components/Matrimony/MainNavbar';
import AstrologyConsultation from './Components/Matrimony/Pages/AstrologyConsultation';
import AstrologerRegister from './Components/MainPages/AstrologerRegister';
import AstrologerLogin from './Components/MainPages/AstrologerLogin';
import AboutUs from './Components/Matrimony/Pages/aboutlovely';
import AdminDashboard from './Components/Matrimony/AdminPanel/AdminDashboard';
import AdminNavbar from './Components/Matrimony/AdminNavbar';
import UserManagement from './Components/Matrimony/AdminPanel/UserManagement';
import AdminPanel from './Components/Matrimony/AdminPanel/AdminPanel';
import AdminMatchmakingPanel from './Components/Matrimony/AdminPanel/AdminMatchmakingPanel';
import AdminNotificationPanel from './Components/Matrimony/AdminPanel/Notificationpageadmin';
import AdminReportPage from './Components/Matrimony/AdminPanel/AdminReportPage';
import AdminReview from './Components/Matrimony/AdminPanel/adminreview';
import AdminHome from './Components/Matrimony/AdminPanel/AdminHome';
import AdminProfile from './Components/Matrimony/AdminPanel/adminProfile';
import AdminLogin from './Components/Matrimony/AdminPanel/loginadmin';
import ViewPayments from './Components/Matrimony/AdminPanel/ViewPayments';
import Emailsms from './Components/Matrimony/AdminPanel/Emailsms';
import Plans from './Components/Matrimony/AdminPanel/Plans';
import UserGuidelines from './Components/Matrimony/AdminPanel/UserGuidelines';
import Aboutus from './Components/Matrimony/AdminPanel/Aboutus';
import Systemsettings from './Components/Matrimony/AdminPanel/Systemsettings';
import UserPaymentHistory from './Components/Matrimony/Pages/UserPaymentHistory';
import RightSideTab from './Components/RightSideTab';
import UserPlansReport from './Components/Matrimony/AdminPanel/UserPlansReport';
import ReportsPage from './Components/Matrimony/AdminPanel/ReportsPage';
import SuccessStoryForm from './Components/Matrimony/Pages/SuccessStoryForm';
import AccountDeactivation from './Components/Matrimony/Pages/AccountDeactivation';
import ContactUs from './Components/Matrimony/Pages/ContactUs';
import PrivateRoute from './Components/PrivateRoute';
import HelpCenter from './Components/Matrimony/Pages/HelpCenter';
import SubmitRequest from './Components/Matrimony/Pages/SubmitRequest';
import UserRequest from './Components/Matrimony/AdminPanel/UserRequest';
import SearchComponent from './Components/Matrimony/Pages/SearchComponent';
import Loader from './Components/Matrimony/Loader'; // import your loader
import AdminContactList from './Components/Matrimony/AdminPanel/AdminContactList';
import MatchProfileListing from './Components/Matrimony/Pages/MatchProfileListing';
import DisclaimerPopup from './Components/Matrimony/Pages/DisclaimerPopup';
import Inbox from './Components/Matrimony/Pages/Inbox';
import BlogsPage from './Components/Matrimony/Pages/BlogsPage';
import BlogsAdmin from './Components/Matrimony/AdminPanel/BlogsAdmin';
import VarankalFAQ from './Components/Matrimony/Pages/VarankalFAQ';
import NotFound from './Components/Matrimony/Pages/NotFound';
import useAlert from "./hooks/useAlert";
import AlertContext from "./contexts/AlertContext";
import AIChatPage from "./Components/Matrimony/Pages/AI/AIChatPage";
import CompatibilityPage from "./Components/Matrimony/Pages/AI/CompatibilityPage";
import MatchPage from "./Components/Matrimony/Pages/AI/MatchPage";
import ProfileAIToolsPage from "./Components/Matrimony/Pages/AI/ProfileAIToolsPage";
import Privacypolicy from "./Components/Matrimony/Pages/Privacypolicy";

// Separate component to use useLocation hook
function MainAppLayout() {
  const location = useLocation();
  const { showAlert, AlertComponent } = useAlert();

  const [loading, setLoading] = useState(false);

  // List of routes where you want to show the loader
  const loaderPaths = ["/homepage", '/homelist', '/profile', '/subscription', '/userpage', "/astrology", "/userpaymenthistory", "/register", "/preference", "/create", "/matchlist", "/inbox"];

  // Check if current path should show loader
  const shouldShowLoader = loaderPaths.some(path => location.pathname.startsWith(path));

  // Optional: simulate loading state for demo
  useEffect(() => {
    setLoading(true);

    let timeoutDuration = 2000; // default

    if (location.pathname === '/homelist', '/matchlist') {
      timeoutDuration = 2200; // longer delay for homelist
    }


    const timer = setTimeout(() => setLoading(false), timeoutDuration);
    return () => clearTimeout(timer);
  }, [location.pathname]);


  // Define allowed paths with route params
  const allowedPaths = [
    "/homepage",
    "/homelist",
    "/subscription",
    "/matchlist",
    "/profile",
    "/userpage/:userId"
  ];

  // Helper function to check if current path matches any allowed route
  const matchAllowedPath = (path) => {
    return allowedPaths.some((route) => {
      if (route.includes(":")) {
        // Convert "/userpage/:userId" to a regex like "^/userpage/[^/]+$"
        const pattern = new RegExp("^" + route.replace(/:\w+/g, "[^/]+") + "$");
        return pattern.test(path);
      }
      return route === path;
    });
  };

  // Usage inside your component
  { matchAllowedPath(location.pathname) && <RightSideTab /> }



  return (
    <AlertContext.Provider value={{ showAlert }}>
      <div className="App">
        <AlertComponent />

        {shouldShowLoader && loading && <Loader />}
        {location.pathname !== "/" && <MainNavbar />}
        {matchAllowedPath(location.pathname, allowedPaths) && <RightSideTab />}

        <Routes>
          <Route path="/" element={<SplashScreen />} />
          <Route path="/signup" element={<Signup />} />
          <Route path="/forgetpassword1" element={<ForgotPassword />} />
          <Route path="/reset_password/:id/:token" element={<ResetPassword />} />
          <Route path="/otpverify" element={<OTPverify />} />
          <Route path="/register" element={<Register />} />
          <Route path="/create" element={<Create />} />
          <Route path="/preference" element={<PartnerPreference />} />
          <Route path="/homelist" element={<HomeList />} />
          <Route path="/homepage" element={<HomePage />} />
          <Route path="/profile" element={<Profile />} />
          <Route path="/subscription" element={<Subscription />} />
          <Route path="/userpage/:userId" element={<UserPage />} />
          <Route path="/chatroom" element={<Chatroom />} />
          <Route path="/chatpage" element={<ChatPage />} />
          <Route path="/notification" element={<Notifications />} />
          <Route path="/legalview" element={<LegalUserView />} />
          <Route path="/astrology" element={<AstrologyConsultation />} />
          <Route path="/review" element={<ReviewPage />} />
          <Route path="/astrologyregister" element={<AstrologerRegister />} />
          <Route path="/astrologylogin" element={<AstrologerLogin />} />
          <Route path="/aboutus" element={<AboutUs />} />
          <Route path="/userpaymenthistory" element={<UserPaymentHistory />} />
          <Route path="/successstory" element={<SuccessStoryForm />} />
          <Route path="/deactivate" element={<AccountDeactivation />} />
          <Route path="/contactus" element={<ContactUs />} />
          <Route path="/helpcenter" element={<HelpCenter />} />
          <Route path="/submitrequest" element={<SubmitRequest />} />
          <Route path="/searchcomponent" element={<SearchComponent />} />
          <Route path="/matchlist" element={<MatchProfileListing />} />
          <Route path='/disclaimer' element={<DisclaimerPopup />} />
          <Route path='/inbox' element={<Inbox />} />
          <Route path="/VarankalFAQ" element={<VarankalFAQ />} />
          <Route path="/Blogs" element={<BlogsPage />} />
          <Route path="/ai" element={<ProfileAIToolsPage />} />
          <Route path="/ai/chat" element={<AIChatPage />} />
          <Route path="/ai/match" element={<MatchPage />} />
          <Route path="/ai/compatibility" element={<CompatibilityPage />} />
          <Route path='/privacypolicy' element={<Privacypolicy/>}/>
          <Route path="*" element={<NotFound />} />

        </Routes>
        <Footer />
      </div>
    </AlertContext.Provider>
  );
}

function App() {
  return (
    <Router>
      <Routes>
        {/* Admin Route: Protected by PrivateRoute */}
        <Route
          path="/admin/*"
          element={
            <PrivateRoute>
              <div className="admin-layout">
                <AdminNavbar />
                <div className="admin-content">
                  <Routes>
                    <Route path="/dashboard" element={<AdminDashboard />} />
                    <Route path="/usermanagement" element={<UserManagement />} />
                    <Route path="/Astrology" element={<AdminPanel />} />
                    <Route path="/matching" element={<AdminMatchmakingPanel />} />
                    <Route path="/notification" element={<AdminNotificationPanel />} />
                    <Route path="/report" element={<AdminReportPage />} />
                    <Route path="/review" element={<AdminReview />} />
                    <Route path="/home" element={<AdminHome />} />
                    <Route path="/profile" element={<AdminProfile />} />
                    <Route path="/view" element={<ViewPayments />} />
                    <Route path="/emailsms" element={<Emailsms />} />
                    <Route path="/plans" element={<Plans />} />
                    <Route path="/guidelines" element={<UserGuidelines />} />
                    <Route path="/about" element={<Aboutus />} />
                    <Route path="/systemsettings" element={<Systemsettings />} />
                    <Route path="/userplans" element={<UserPlansReport />} />
                    <Route path="/overallusersreports" element={<ReportsPage />} />
                    <Route path="/request" element={<UserRequest />} />
                    <Route path="/contactuslist" element={<AdminContactList />} />
                    <Route path="/blogs" element={<BlogsAdmin />} />
                    <Route path="*" element={<NotFound />} />

                  </Routes>
                </div>
              </div>
            </PrivateRoute>
          }
        />

        {/* Admin Login Route (accessible without auth) */}
        <Route path="/admin" element={<AdminLogin />} />

        {/* Public/Main App Route */}
        <Route path="/*" element={<MainAppLayout />} />
      </Routes>
    </Router>
  );
}
export default App;

